<template>
    <div class="admin-user">
        <div class="paca-table">
            <div class="paca-table__header">
                <div class="paca-table__header-item item-column column-lock"></div>
                <div class="paca-table__header-item item-column column-password"></div>
                <div class="paca-table__header-item item-column column-edit"></div>
                <div class="paca-table__header-item item-column column-nick-name">暱稱({{userList.length}})</div>
                <div class="paca-table__header-item item-column column-admin">管理</div>
                <div class="paca-table__header-item item-column column-partner">夥伴</div>
                <div class="paca-table__header-item item-column column-agent">代理</div>
                <div class="paca-table__header-item item-column column-site-owner">企業</div>
                <div class="paca-table__header-item item-column column-free-owner">業者</div>
                <div class="paca-table__header-item item-column column-identity">身分</div>
                <div class="paca-table__header-item item-column column-create">建立時間</div>
                <div class="paca-table__header-item item-column column-last-login">最後登入</div>
                <div class="paca-table__header-item item-column column-action"></div>
            </div>
            <div class="paca-table__body" v-if="viewUserList.length>0">
                <div class="paca-table__body-col" v-for="(item,index) in viewUserList" :key="index">
                    <div class="paca-table__body-col-list" :class="`list-${index}`" >
                        <div class="paca-table__body-col-list-item item-column column-lock">
                            <button class="column-lock-icon" :class="item.is_locked==0?'unlock el-icon-unlock':'lock paca-icon-lock'" @click="lockItem(index, item)"></button>
                        </div>
                        <div class="paca-table__body-col-list-item item-column column-password">
                            <button class="column-password-icon el-icon-key" :disabled="item.is_locked==1" @click="openPasswordDialog(item)"></button>
                        </div>
                        <div class="paca-table__body-col-list-item item-column column-edit">
                            <button type="button" class="column-edit-icon el-icon-edit" @click="editUser(item,'info')" :disabled="item.is_locked==1"></button>
                        </div>
                        <div class="paca-table__body-col-list-item item-column column-nickname overflow-text">
                            <span class="column-nickname-text overflow-text">{{item.nickname}}</span>
                        </div>
                        <div class="paca-table__body-col-list-item item-column column-admin">
                            <button class="checkbox-button" :class="{'is-check': item.is_admin==1}" @click="changeUserIdentity(item,'is_admin')" :disabled="item.is_locked==1"></button>
                        </div>
                        <div class="paca-table__body-col-list-item item-column column-partner">
                            <button class="checkbox-button" :class="{'is-check': item.is_partner==1}" @click="changeUserIdentity(item,'is_partner')" :disabled="item.is_locked==1"></button>
                        </div>
                        <div class="paca-table__body-col-list-item item-column column-agent">
                            <button class="checkbox-button" :class="{'is-check': item.is_agent==1}" @click="changeUserIdentity(item,'is_agent')" :disabled="item.is_locked==1"></button>
                        </div>
                        <div class="paca-table__body-col-list-item item-column column-site-owner">
                            <button class="checkbox-button" :class="{'is-check': item.is_siteowner==1}" @click="changeUserIdentity(item,'is_siteowner')" :disabled="item.is_locked==1"></button>
                        </div>
                        <div class="paca-table__body-col-list-item item-column column-free-owner">
                            <button class="checkbox-button" :class="{'is-check': item.is_free_siteowner==1}" @click="changeUserIdentity(item,'is_free_siteowner')" :disabled="item.is_locked==1"></button>
                        </div>
                        <div class="paca-table__body-col-list-item item-column column-identity">
                            <el-select v-model="item.identity" @change="changeUserIdentity(item, item.identity)">
                                <el-option v-for="(identityItem, identityIndex) in identityList" :key="identityIndex"
                                :label="identityItem.key" :value="identityItem.value"></el-option>
                            </el-select>
                        </div>
                        <div class="paca-table__body-col-list-item item-column column-create">{{item.created_at}}</div>
                        <div class="paca-table__body-col-list-item item-column column-last-login">{{item.last_login}}</div>
                        <div class="paca-table__body-col-list-item item-column column-action">
                            <button class="column-action-button el-icon-document" @click="openItemInfoDialog(item)"></button>
                        </div>
                    </div>
                </div>
                <button type="button" class="paca-table__body-more" v-if="isShowMoreButton" @click="userIteration()">更多</button>
            </div>
            <div class="paca-table__empty" v-else></div>
        </div>
        <el-dialog class="admin-user__edit-dialog" :visible.sync="isEditPasswordDialogOpen">
            <div class="admin-user__edit-dialog__header" slot="title">更改密碼</div>
            <div class="admin-user__edit-dialog__body">
                <form @submit.prevent @keyup.enter="putAdminUserInfo()">
                    <lgn-form-item label-position="left">
                        <div slot="label">暱稱</div>
                        <div slot="input" class="admin-user__edit-dialog__body-edit-nickname">{{passwordForm.nickname}}</div>
                    </lgn-form-item>
                    <lgn-form-item label-position="left">
                        <div slot="label">新密碼</div>
                        <lgn-input slot="input" class="admin-user__edit-dialog__body-edit-name" v-model="passwordForm.password"></lgn-input>
                    </lgn-form-item>
                </form>
            </div>
            <div class="admin-user__edit-diaog__footer" slot="footer">
                <el-button class="admin-user__edit-dialog__footer-submit-button main-button" @click="putEditUserPassword(passwordForm)">送出</el-button>
            </div>
        </el-dialog>
        <el-dialog class="admin-user__edit-dialog" :visible.sync="isEditDialogOpen">
            <div class="admin-user__edit-dialog__header" slot="title">資料更改</div>
            <div class="admin-user__edit-dialog__body">
                <form @@submit.prevent @keyup.enter="putAdminUserInfo()">
                    <lgn-form-item label-position="left">
                        <div slot="label">信箱</div>
                        <lgn-input slot="input" class="admin-user__edit-dialog__body-edit-email" v-model="editItem.email"></lgn-input>
                    </lgn-form-item>
                    <lgn-form-item label-position="left">
                        <div slot="label">暱稱</div>
                        <lgn-input slot="input" class="admin-user__edit-dialog__body-edit-name" v-model="editItem.nickname"></lgn-input>
                    </lgn-form-item>
                </form>
            </div>
            <div class="admin-user__edit-diaog__footer" slot="footer">
                <el-button class="admin-user__edit-dialog__footer-submit-button main-button" @click="putAdminUserInfo()">送出</el-button>
            </div>
        </el-dialog>
        <el-dialog class="admin-user__info-dialog" :visible.sync="isInfoDialogOpen" v-if="userInfoDialogInfo">
            <div slot="title">{{userInfoDialogInfo.nickname}}</div>
            <div class="admin-user__info-dialog__body">
                <div class="admin-user__info-dialog__body-item">
                    <div class="admin-user__info-dialog__body-item-label">用戶編號</div>
                    <div class="admin-user__info-dialog__body-item-value">{{userInfoDialogInfo.id}}</div>
                </div>
                <div class="admin-user__info-dialog__body-item">
                    <div class="admin-user__info-dialog__body-item-label">用戶信箱</div>
                    <div class="admin-user__info-dialog__body-item-value">{{userInfoDialogInfo.email}}</div>
                </div>
                <div class="admin-user__info-dialog__body-item">
                    <div class="admin-user__info-dialog__body-item-label">建立時間</div>
                    <div class="admin-user__info-dialog__body-item-value">{{userInfoDialogInfo.created_at}}</div>
                </div>
                <div class="admin-user__info-dialog__body-item">
                    <div class="admin-user__info-dialog__body-item-label">最後登入</div>
                    <div class="admin-user__info-dialog__body-item-value">{{userInfoDialogInfo.last_login}}</div>
                </div>
            </div>
            <div slot="footer">
                <button type="button" class="admin-user__info-dialog__footer-button main-button" @click="CloseItemInfoDialog">確認</button>
            </div>
        </el-dialog>
        
    </div>
</template>
<script>
import * as api from '@/script/apiService/api.js'
import itemTrim from '@/script/trim/trim.js'
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
import lgnFormItem from '@/lgnComponents/lgnForm/lgnFormItem.vue'
import {getFullTime, timeFormatStandardToString} from "@/script/time/time.js"
import {validPassword} from "@/script/valid/valid.js"
export default {
    name: "User",
    data(){
        return{
            userList: [],
            viewUserList: [],
            isEditDialogOpen: false,
            editItem: {},
            viewMoreCount: 0,
            isShowMoreButton: true,
            isInfoDialogOpen: false,
            userInfoDialogInfo: null,
            tableLoading: false,
            identityList: [
                {key: '管理', value: 'is_admin'},
                {key: '夥伴', value: 'is_partner'},
                {key: '代理', value: 'is_agent'},
                {key: '企業', value: 'is_siteowner'},
                {key: '業者', value: 'is_free_siteowner'}
            ],
            isEditPasswordDialogOpen: false,
            passwordForm: {}
        }
    },
    components: {
        lgnInput,
        lgnFormItem
    },
    methods: {
        async getAdminUserList(){
            this.viewMoreCount = 0;
            this.isShowMoreButton = true;
            this.viewUserList = [];
            this.$nextTick(() => {
                this.tableLoading = true;
            });
            let res = await api.getAdminUserList();
            if(!res.error_status){
                setTimeout(function(){
                    res.splice(res.findIndex(item => item.nickname == this.userName), 1);
                    res.forEach((item) => {
                        let createTime = null;
                        let lastLoginTime = null;
                        if(item.created_at){
                            createTime = getFullTime(new Date(item.created_at));
                        } else{
                            createTime = "無";
                        }
                        if(item.last_login){
                            lastLoginTime = getFullTime(new Date(timeFormatStandardToString(item.last_login)));
                        } else {
                            lastLoginTime = "無";
                        }
                        item.identity = null;
                        let identityList = ["is_admin", "is_partner", "is_agent", "is_siteowner", "is_free_siteowner"];
                        identityList.forEach((identity) => {
                            if(item[identity] == 1){
                                item.identity = identity;
                            }
                        })
                        item.created_at = createTime;
                        item.last_login = lastLoginTime;
                    })
                    this.userList = res;
                    this.tableLoading = false;
                    setTimeout(function(){
                        this.userIteration();
                    }.bind(this), 300);
                }.bind(this), 300);
            }else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
        },
        userIteration(){
            if((this.viewMoreCount + 1)*30 >= this.userList.length){
                this.isShowMoreButton = false;
            }
            this.viewUserList = this.viewUserList.concat(this.userList.slice(this.viewMoreCount*30, (this.viewMoreCount + 1) * 30));
            this.viewMoreCount += 1;
        },
        openPasswordDialog(item){
            this.passwordForm = JSON.parse(JSON.stringify(item));
            let bigText = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
            let smallText = "abcdefghijklmnopqrstuvwxyz".split("");
            let numberText = "0123456789".split("");
            let code = "";
            let i = 0;
            for(i;i < 9; i++){
                if(i < 3){
                    code += bigText[parseInt(Math.random()*26+1) - 1];
                }else if(i < 6){
                    code += smallText[parseInt(Math.random()*26+1) - 1];
                }else{
                    code += numberText[parseInt(Math.random()*10+1) - 1];
                }
            }
            this.passwordForm.password = code;
            this.isEditPasswordDialogOpen = true;
        },
        async putEditUserPassword(item){
            let data = {
                email: item.email,
                nickname: item.nickname,
                password: item.password
            }
            if(data.password.trim().length == 0){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "密碼不得為空!"
                })
                return false
            }
            let res = await api.putAdminChangeUserPassword(item.id, data);
            if(!res.error_status){
                this.isEditPasswordDialogOpen = false;
                this.$message.success({
                    duration: 2500,
                    showClose: true,
                    message: "修改密碼成功!"
                })
            }
        },
        editUser(item,target){
            this.editTarget = target;
            this.editItem = {...item};
            this.editItem.password = "";
            this.isEditDialogOpen = true;
        },
        changeUserIdentity(item,target){
            let identityList = ["is_admin", "is_partner", "is_agent", "is_siteowner", "is_free_siteowner"];
            identityList.forEach((identity) => {
                if(identity == target){
                    item[identity] = 1;
                    item.identity = identity;
                }else{
                    item[identity] = 0;
                }
            })
            this.saveUserAuthority(item, target);
        },
        async putAdminUserInfo(){
            let data = {
                "email": this.editItem.email,
                "nickname": this.editItem.nickname
            }
            if(data.email.trim().length == 0 || data.nickname.trim().length == 0){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "信箱及暱稱不得為空!"
                })
                return false;
            }
            let res = await api.putAdminUserInfo(this.editItem.id,itemTrim(data))
            if(!res.error_status){
                this.getAdminUserList();
                this.isEditDialogOpen = false;
            }
        },
        async lockItem(index, item){
            this.userList[index].is_locked = (this.userList[index].is_locked + 1) % 2;
            let res = null;
            if(this.userList[index].is_locked == 0){
                res = await api.putUserUnLock(this.userList[index].id);
            }else if(this.userList[index].is_locked==1){
                res = await api.putUserLock(this.userList[index].id);
            }
            if(!res.error_status){
            }
        },
        async saveUserAuthority(item, target){
            let identityData = target.split('').slice(3).join('').split("_").join('');
            let id = item.id;
            let IdentityResult = await api.putUserIdentity(id, identityData);
            if(IdentityResult.error_status){
                this.$message.error({
                    showClose: true,
                    duration: 2500,
                    message: this.$t("common.error")
                })
            }
            if(!IdentityResult.error_status){
            }
        },
        openItemInfoDialog(item){
            this.userInfoDialogInfo = JSON.parse(JSON.stringify(item));
            this.isInfoDialogOpen = true;
        },
        CloseItemInfoDialog(){
            this.isInfoDialogOpen = false;
        }
    },
    async activated(){
        this.getAdminUserList();
    },
    computed: {
        userName(){
            return this.$store.state.userInfo.nickname
        }
    },
    watch: {
        tableLoading(value){
            let hasData = document.querySelector(".paca-table__body");
            let loadingStyle = "";
            let asideWidth = document.querySelector(".el-aside").offsetWidth;
            if(hasData){
                loadingStyle = hasData.offsetHeight > document.querySelector(".el-main").offsetHeight/2 ? 'screen-align' : 'empty-align';
            }
            if(asideWidth > 150){
                loadingStyle += " collapse-open";
            }else if(asideWidth > 50){
                loadingStyle += " collapse-exist";
            }
            if(value == true){
                this.loadingMethod = this.$loading({
                    lock: true,
                    target: '.paca-table__empty',
                    text: '搜尋中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255,255,255,0.8)',
                    customClass: loadingStyle
                });
            }else{
                if(this.loadingMethod != null){
                    this.loadingMethod.close();
                }
            }
        },
    },
}
</script>